export default __webpack_public_path__ + "static/media/Magical Strings 2018 (221 of 264) (3).69767503.jpg";